import Container from './container'
import ProviderRegistrationOnBoarding from './onboarding'
import { ServiceList as CCSServiceRegistrations } from './service-list'

export { ProviderRegistrationOnBoarding, CCSServiceRegistrations }
export default Container



// WEBPACK FOOTER //
// ./src/providers-registrations/index.js